export default __webpack_public_path__ + "static/logo-bollene-aventure-fc174653751a173317d74b8a58a6cfd1.png";